import { render, staticRenderFns } from "./IEWarning.vue?vue&type=template&id=4df6a9d3&"
import script from "./IEWarning.vue?vue&type=script&lang=js&"
export * from "./IEWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports